module.exports = __webpack_public_path__ + "img/resource-ys-active.df9ea8d3.png";